export const parseStatus = status => {
  // Check if domain is authenticated as that is last state
  if (status.includes('AUTHENTICATED')) return 'Authenticated';
  if (status.includes('VERIFIED')) return 'Verified';

  // Return pending state if domain is not authenticated or verified
  return 'Pending verification';
};

const sortHelper = (a, b) => {
  return a > b ? 1 : a < b ? -1 : 0;
};

export const sortDomainList = obj => {
  const sortedArr = [];

  Object.keys(obj)
    .filter(name => {
      // Filter any domain that has a status of FREE
      return !obj[name].includes('FREE');
    })
    // sort alphabetically regardless of letter case
    .sort((a, b) => {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    })
    .map(name => {
      const domain = {
        name,
        status: parseStatus(obj[name]),
      };

      return sortedArr.push(domain);
    });

  // sort by Verified status first
  return sortedArr.sort((a, b) => {
    return sortHelper(b.status, a.status);
  });
};
